import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

import { DropDownModel } from '../../../../models/dropDownModel';
import { SearchParametersService } from '../../../../services/SearchParameters/search-parameters.service';
import { UserService } from '../../../../services/user/user.service';
import {
  FIELDTYPE,
  IChipEntry,
  IDropDownListEntry,
} from '../../mdm-input/mdm-input-settings';
import { ISearchParameters } from './searchParameters';

@Component({
  selector: 'app-search-parameters',
  templateUrl: './search-parameters.component.html',
  styleUrls: ['./search-parameters.component.scss'],
  standalone: false,
})
export class SearchParametersComponent implements OnInit {
  integerField: FIELDTYPE = FIELDTYPE.INTEGER;
  confidenceLabels: IDropDownListEntry[] = [
    this.getDropDownListEntry('high', 'High'),
    this.getDropDownListEntry('medium', 'Medium'),
    this.getDropDownListEntry('low', 'Low'),
  ];
  yesNoDropdownReviewed: IDropDownListEntry[] = [
    this.getDropDownListEntry('yes', 'Yes'),
    this.getDropDownListEntry('no', 'No'),
  ];
  yesNoDropdownNationalContract: IDropDownListEntry[] = [
    this.getDropDownListEntry('yes', 'Yes'),
    this.getDropDownListEntry('no', 'No'),
  ];
  possibleSources: IDropDownListEntry[] = [];
  unspscCodes: IDropDownListEntry[] = [];
  pscDescriptions: IDropDownListEntry[] = [];
  vendors: IDropDownListEntry[] = [];
  syncCodeSubCategoryDescriptions: IDropDownListEntry[] = [];
  syncCodeGroupDescriptions: IDropDownListEntry[] = [];
  unspscCodesLoaded: boolean = false;
  pscDescriptionsLoaded: boolean = false;
  vendorsLoaded: boolean = false;
  syncCodesLoaded: boolean = false;

  selectedSources: IChipEntry[] = [];
  selectedSyncCodeSubCategoryDescriptions: IChipEntry[] = [];
  selectedSyncCodeGroupDescriptions: IChipEntry[] = [];
  selectedProductKeys: IChipEntry[] = [];
  selectedVendorPartNumbers: IChipEntry[] = [];
  selectedVendorProductDescriptions: IChipEntry[] = [];
  selectedContractNumbers: IChipEntry[] = [];
  selectedVendorNames: IChipEntry[] = [];
  selectedUnspscCodes: IChipEntry[] = [];
  selectedPscCategories: IChipEntry[] = [];
  selectedBatchIds: IChipEntry[] = [];
  selectedConfidenceLabels: IChipEntry[] = [];
  selectedReviewed: IChipEntry[] = [];
  selectedOnNationalContract: IChipEntry[] = [];

  parameters: ISearchParameters;
  isInternalUser: boolean = false;

  @Output() searchParameters: EventEmitter<any> = new EventEmitter<any>();
  @Output() searchClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() cancelSearchClicked: EventEmitter<any> = new EventEmitter<any>();
  @Output() clearParametersClicked: EventEmitter<any> = new EventEmitter<any>();

  @Input() incomingBatchId: string;
  @Input() searchInProgress: boolean = false;

  constructor(
    private searchParameterService: SearchParametersService,
    public user: UserService,
  ) {
    let ps = this;
    user.isInternal.subscribe(u => {
      this.isInternalUser = u;
    });
    this.searchParameterService.getKnownSources().then(function (
      s: DropDownModel[],
    ) {
      let allSources = ps.getDropDownListEntry('0', 'All');
      ps.possibleSources.push(allSources);
      if (s != null) {
        for (let i of s)
          ps.possibleSources.push(
            ps.getDropDownListEntry(i.value, i.viewValue),
          );
      }
    });
    this.searchParameterService.UnspscCodes.then(codes => {
      this.unspscCodes = [];
      if (this.isInternalUser) {
        codes
          .sort((a, b) => {
            return +a.code - +b.code;
          })
          .forEach(c => {
            this.unspscCodes.push(
              ps.getDropDownListEntry(c.code, c.code + ' - ' + c.description),
            );
          });
      } else {
        codes
          .sort((a, b) => {
            return a.description
              .toLowerCase()
              .localeCompare(b.description.toLowerCase());
          })
          .forEach(c => {
            this.unspscCodes.push(
              ps.getDropDownListEntry(c.code, c.description),
            );
          });
      }
      this.unspscCodesLoaded = true;
    });
    this.searchParameterService.PSCDescriptions.then(d => {
      this.pscDescriptions = [];
      d.sort((a, b) => {
        return a.description
          .toLowerCase()
          .localeCompare(b.description.toLowerCase());
      }).forEach(c => {
        this.pscDescriptions.push(
          ps.getDropDownListEntry(c.description, c.description),
        );
      });
      this.pscDescriptionsLoaded = true;
    });
    this.searchParameterService.Vendors.then(v => {
      this.vendors = [];
      v.sort((a, b) => {
        return a.name.toLowerCase().localeCompare(b.name.toLowerCase());
      }).forEach(c => {
        this.vendors.push(ps.getDropDownListEntry(c.name, c.name));
      });
      this.vendorsLoaded = true;
    });
    this.searchParameterService.SyncCodeData.then(s => {
      this.syncCodeGroupDescriptions = [];
      this.syncCodeSubCategoryDescriptions = [];
      s.sort((a, b) => {
        return a.groupDescription
          .toLowerCase()
          .localeCompare(b.groupDescription.toLowerCase());
      }).forEach(c => {
        if (
          this.syncCodeGroupDescriptions.find(
            v => v.key == c.groupDescription,
          ) == null
        )
          this.syncCodeGroupDescriptions.push(
            ps.getDropDownListEntry(c.groupDescription, c.groupDescription),
          );
      });

      s.sort((a, b) => {
        return a.subCategoryDescription
          .toLowerCase()
          .localeCompare(b.subCategoryDescription.toLowerCase());
      }).forEach(c => {
        this.syncCodeSubCategoryDescriptions.push(
          ps.getDropDownListEntry(
            c.subCategoryDescription,
            c.subCategoryDescription,
          ),
        );
      });
      this.syncCodesLoaded = true;
    });
  }

  clearParameters(): void {
    this.selectedSources = [];
    this.selectedSyncCodeSubCategoryDescriptions = [];
    this.selectedSyncCodeGroupDescriptions = [];
    this.selectedProductKeys = [];
    this.selectedVendorPartNumbers = [];
    this.selectedVendorProductDescriptions = [];
    this.selectedContractNumbers = [];
    this.selectedVendorNames = [];
    this.selectedUnspscCodes = [];
    this.selectedPscCategories = [];
    this.selectedBatchIds = [];
    this.selectedConfidenceLabels = [];
    this.selectedReviewed = [];
    this.selectedOnNationalContract = [];

    this.clearDropDownListEntry(this.confidenceLabels);
    this.clearDropDownListEntry(this.possibleSources);
    this.clearDropDownListEntry(this.unspscCodes);
    this.clearDropDownListEntry(this.pscDescriptions);
    this.clearDropDownListEntry(this.vendors);
    this.clearDropDownListEntry(this.syncCodeSubCategoryDescriptions);
    this.clearDropDownListEntry(this.syncCodeGroupDescriptions);
    this.clearDropDownListEntry(this.yesNoDropdownReviewed);
    this.clearDropDownListEntry(this.yesNoDropdownNationalContract);
    this.clearParametersClicked.emit();
  }

  private clearDropDownListEntry(entry: IDropDownListEntry[]): void {
    entry.forEach(e => {
      e.isSelected = false;
    });
  }

  getDropDownListEntry(key: string, value: string): IDropDownListEntry {
    return {
      key: key,
      value: value,
      isDisabled: false,
      isSelected: false,
    };
  }

  disableSecondary(): boolean {
    this.dataUpdate();
    if (this.parameters.VendorNames.length > 0) return false;
    if (this.parameters.ProductKeys.length > 0) return false;
    if (this.parameters.ContractNumbers.length > 0) return false;
    if (this.parameters.VendorProductDescriptions.length > 0) return false;
    if (this.parameters.VendorPartNumbers.length > 0) return false;
    if (this.parameters.BatchIds.length > 0) return false;
    if (this.parameters.ContractNumbers.length > 0) return false;
    return true;
  }

  cancelSearch() {
    this.cancelSearchClicked.emit();
  }

  searchClick() {
    this.searchClicked.emit();
  }

  dataUpdate(): void {
    this.parameters = {
      ProductKeys: this.selectedProductKeys.map(p => p.key).toString(),
      VendorPartNumbers: this.selectedVendorPartNumbers
        .map(vpn => vpn.key)
        .toString(),
      VendorNames: this.selectedVendorNames
        .map(v => v.key)
        .join(String.fromCharCode(30))
        .toString(),
      VendorProductDescriptions: this.selectedVendorProductDescriptions
        .map(d => d.key)
        .toString(),
      ProductSpendCatergories: this.selectedPscCategories
        .map(p => p.key)
        .toString(),
      UnspscCodes: this.selectedUnspscCodes.map(u => u.key).toString(),
      UnspscDescription: this.selectedUnspscCodes.map(u => u.value).toString(),
      SyncSubcategoryDescriptions: this.selectedSyncCodeSubCategoryDescriptions
        .map(s => s.key)
        .toString(),
      SyncGroupDescriptions: this.selectedSyncCodeGroupDescriptions
        .map(s => s.key)
        .toString(),
      ContractNumbers: this.selectedContractNumbers.map(c => c.key).toString(),
      BatchIds: this.selectedBatchIds.map(c => c.key).toString(),
      ConfidenceLabels: this.selectedConfidenceLabels
        .map(c => c.key)
        .toString(),
      Sources: this.selectedSources.map(s => s.key).toString(),
      Reviewed: this.selectedReviewed.map(s => s.key).toString(),
      OnNationalContract: this.selectedOnNationalContract
        .map(s => s.key)
        .toString(),
      MaxRows: 25000,
    };
    this.searchParameters.emit(this.parameters);
  }

  ngOnInit() {
    if (this.incomingBatchId) {
      this.selectedBatchIds = [
        { key: this.incomingBatchId, value: this.incomingBatchId },
      ];
    }
  }
}
